import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import CardHeader from "../../../../Universal/CardHeader.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";

const BarGraphChart = ({ graphData }) => {
  return (
    <>
      <CardHeader
        title="Grants Collections"
        actionBtn={<SelectFilter />}
        headerStyle={{ borderBottom: "none" }}
      />
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={graphData}
          margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" textAnchor="end" height={60} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="grants" fill="#41C3B2" />
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default BarGraphChart;
